import React, { useState } from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import moment from 'moment';
import { getDataList } from '../../api/common';

// Cache módulo-nivel: persiste entre renders y entre filas de la misma sesión
const _creadoPorCache = {};

/**
 * Modal que muestra el detalle de un equipo adicionado posteriormente a la OT.
 *
 * @param {boolean}  show        - Controla visibilidad
 * @param {Function} onHide      - Callback para cerrar
 * @param {Object}   equipo      - Objeto equipmentInOt (necesita .equipo, .consecutivo,
 *                                 .motivoAdicion, .creadoPor, .createdAt)
 */
const ModalDetalleAdicion = ({ show, onHide, equipo }) => {
  const [creadoPorInfo, setCreadoPorInfo] = useState(null);
  const [loadingCreador, setLoadingCreador] = useState(false);

  // Carga el usuario la primera vez que el modal se abre (lazy + cache)
  const handleEntered = async () => {
    const uid = equipo?.creadoPor?._id || equipo?.creadoPor;
    if (!uid) return;
    if (_creadoPorCache[uid]) {
      setCreadoPorInfo(_creadoPorCache[uid]);
      return;
    }
    try {
      setLoadingCreador(true);
      const res = await getDataList('Usuarios', {
        conditions: { _id: uid },
        fields: { nombre: 1, apellido: 1 },
        options: { limit: 1 },
      });
      const user = res.data?.data?.[0] || null;
      if (user) _creadoPorCache[uid] = user;
      setCreadoPorInfo(user);
    } catch {
      setCreadoPorInfo(null);
    } finally {
      setLoadingCreador(false);
    }
  };

  const nombreCreador = loadingCreador
    ? null
    : creadoPorInfo
      ? `${creadoPorInfo.nombre || ''} ${creadoPorInfo.apellido || ''}`.trim() || 'N/A'
      : 'N/A';

  return (
    <Modal show={show} onHide={onHide} onEntered={handleEntered} centered size="sm">
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title className="fs-6">
          <i className="bi bi-plus-circle me-2" />
          {equipo?.equipo?.item?.nombre || 'Equipo'}
          {equipo?.consecutivo ? ` — ${equipo.consecutivo}` : ''}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <dl className="mb-0 small">
          <dt className="text-muted">Motivo de adición</dt>
          <dd>
            {equipo?.motivoAdicion || (
              <span className="text-muted fst-italic">Sin motivo registrado</span>
            )}
          </dd>

          <dt className="text-muted">Creado por</dt>
          <dd>
            {loadingCreador
              ? <Spinner animation="border" size="sm" />
              : nombreCreador
            }
          </dd>

          <dt className="text-muted">Fecha de adición</dt>
          <dd>
            {equipo?.createdAt
              ? moment(equipo.createdAt).format('DD/MM/YYYY HH:mm')
              : 'N/A'}
          </dd>
        </dl>
      </Modal.Body>

      <Modal.Footer className="py-1">
        <Button size="sm" variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDetalleAdicion;
